// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"482":"dad2de2f","625":"9bb321ef","635":"d93f1a60","836":"cef64679"}[chunkId] + ".css";
};